import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL,
 headers: { Authorization: `Bearer ${getToken()}` }
});

// Fetch all users (legacy)
export const fetchAllUsers = () => api.get("/admin/users");

// Fetch users with pagination and search
export const fetchAllUsersWithPagination = (params) => {
 const queryParams = new URLSearchParams();
 
 if (params.page !== undefined) queryParams.append('page', params.page);
 if (params.size) queryParams.append('size', params.size);
 if (params.search) queryParams.append('search', params.search);
 if (params.sortBy) queryParams.append('sortBy', params.sortBy);
 if (params.sortDir) queryParams.append('sortDir', params.sortDir);
 
 return api.get(`/admin/users?${queryParams.toString()}`);
};

// Get user details
export const getUserDetails = (userId) => api.get(`/admin/users/${userId}/details`);

// Suspend / Activate
export const suspendUser = (id, reason) =>
 api.put(`/admin/users/${id}/suspend`, null, {
 params: { suspend: true, reason },
 });

export const activateUser = (userId) => api.put(`/admin/users/${userId}/activate`);

// Subscription history
export const getUserSubscriptionHistory = (userId) =>
 api.get(`/admin/users/${userId}/subscriptions`);

// Increase subscription sessions
export const increaseSubscriptionSessions = (userId, subscriptionId, additionalSessions) =>
 api.put(`/admin/users/${userId}/subscriptions/${subscriptionId}/increase-sessions`, null, {
 params: { additionalSessions }
 });

// WhatsApp related APIs
export const updateWhatsAppInfo = (userId, whatsappData) =>
 api.put(`/admin/users/${userId}/whatsapp`, whatsappData);

export const sendWhatsAppMessage = (userId, message) =>
 api.post(`/admin/users/${userId}/send-whatsapp`, { message });

export const sendBulkWhatsAppMessage = (userIds, message) =>
 api.post(`/admin/users/bulk-whatsapp`, { 
 userIds, 
 message 
 });

export const getWhatsAppStats = () =>
 api.get(`/admin/users/whatsapp-stats`);
